<template>
	<form class="container-sm mh-100 pt-10" @submit.prevent="submit" autocomplete="off">
		<div class="pb-4 vstack gap-3">
			<div class="text-center">
				<router-link :to="{ name: 'home' }" class="d-inline-block">
					<img src="@/assets/img/logo/complete.png" class="h-rem-10" alt="logo">
				</router-link>
			</div>
			<div class="ls-tight lh-sm text-md text-center px-5 px-md-10">¡Unite a nosotros!</div>
			<div class="card text-bg-white border-0 shadow-none">
				<div class="card-body vstack gap-5">
					<div class="vstack gap-3">
						<CommonFormInputText v-model="name" title="Nombre" placeholder="Ingrese su nombre" :focus="true" :validation="validation.name" />
						<CommonFormInputEmail v-model="email" title="Email" placeholder="Ingrese su email" :validation="validation.email" />
						<CommonFormInputPassword v-model="password" title="Contraseña" placeholder="Ingrese su contraseña" :validation="validation.password" />
					</div>
					<div class="text-center" v-if="validationExternal.length > 0">
						<div class="invalid-feedback fw-bold d-block m-0" v-for="(error, index) in validationExternal" v-bind:key="index">{{ error }}</div>
					</div>
					<div class="text-center d-grid gap-3">
						<button type="submit" class="btn btn-md btn-primary" :disabled="submitting">Registrarse</button>
					</div>
				</div>
			</div>
		</div>
		<div class="text-center fw-bold pb-10">
			¿Ya tienes una cuenta?
			<router-link :to="{ name: 'auth.login' }" class="link-primary ps-2">Ingresar</router-link>
		</div>
	</form>
</template>

<script>
	import { reactive, toRefs } from 'vue';
	import store from '@/store';
	import useVuelidate from '@vuelidate/core';
	import { required, minLength, maxLength, email } from '@/helpers/i18n/validators';
	import composableForm from '@/composables/form';
	import composableRedirect from '@/composables/redirect';

	export default {
		setup() {
			const { submitting, validationExternal, catchError } = composableForm();
			const { redirectNext } = composableRedirect();

			const form = reactive({
				name: '',
				email: '',
				password: ''
			});

			const validation = useVuelidate({
				name: {
					required,
					minLength: minLength(3),
					maxLength: maxLength(150)
				},
				email: {
					required,
					email
				},
				password: {
					required,
					minLength: minLength(8),
					maxLength: maxLength(16)
				}
			}, form);

			const submit = async () => {
				if(submitting.value) return;
				validationExternal.value = [];
				if(!await validation.value.$validate()) return;

				submitting.value = true;
				store.dispatch('auth/signup', form).then(setUser).catch(catchError);
			}

			const setUser = () => {
				store.dispatch('auth/me').then(redirectNext).catch(catchError);
			}

			return { ...toRefs(form), validation, validationExternal, submitting, submit };
		}
	}
</script>